/* eslint-disable no-nested-ternary */
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import {
  LevelButton, ClientAndReportingDate, Client, ReportingDate,
} from 'Components/HomeHeader/HomeHeader.styles';
import AppContext from 'AppContext';
import CDATA from 'Services/CDATA';
import GrpHeader from 'Library/GrpHeader/GrpHeader';
import GrpToolbar from 'Library/GrpToolbar/GrpToolbar';
import GrpGrid from 'Library/GrpGrid/GrpGrid';
import GrpSpinner from 'Components/GrpSpinner/GrpSpinner';
import GrpError from 'Components/GrpError/GrpError';
import { DashboardView, DashboardBody } from '../InsuranceProductClassDashboard.styles';

class InsPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      api_name: 'PRIIPS_app_INS_Risk_Performance_Calculation_Preview_v2',
      loading: true,
      failed: false,
      totalRowCount: 0,
      displayedRowCount: 0,
      productClassPk: this.props.location.productClassPk ? this.props.location.productClassPk : '',
    };
  }

  componentDidMount() {
    this.getMetadata();
  }

  async getMetadata() {
    try {
      const columns = await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_GET_COLUMNS',
        '',
        {
          API_NAME: this.state.api_name,
          MERGE_QUEUE_ID: -99,
        },
        'Error retrieving column names and metadata.',
      );
      this.setState({
        columnDefs: this.mapColumns(columns.value),
        rawColumns: columns.value,
      });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading the columns for this table. Please try again. If the issue persists, contact your administrator.',
      });
      console.log(err);
    }
  }

  async getData() {
    try {
      this.gridApi.updateGridOptions({ rowData:[]});
      const data = await CDATA.makeRequest(
        'POST',
        this.state.api_name,
        '',
        {
          Client_Code: this.context.state.selectedClient.code,
          CalcDate: this.context.state.selectedReportingDate.code,
          ProductClassPk: this.state.productClassPk,
        },
        'Error retrieving data.',
      );
      const totalRowCount = data && data['@odata.count'] !== 0 ? data['@odata.count'] : data.value.filter((item) => item.return_value !== '0').length;
      const rowData = [];
      this.gridApi.forEachNode((node) => rowData.push(node.data));
      setTimeout(
        ()=>{
          if(JSON.stringify(rowData) !== JSON.stringify(data.value.filter((item) => item.return_value !== '0')))
            this.gridApi.updateGridOptions({ rowData: data.value.filter((item) => item.return_value !== '0')});
          }
      ,10);
      this.gridApi.onFilterChanged();
      this.setState({ loading: false, totalRowCount });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  // refreshData() {
  //   this.setState({ loading: true},()=> this.getData());
  // }

  mapColumns = (rawColumns) => rawColumns.map((x) => ({
    field: x.dv_column,
    headerName: x.display_name,
    hide: x.is_hidden,
    editable: x.editable,
    comparator: x.sorttype !== undefined && x.sorttype.toLowerCase() === 'numeric' && ((value1, value2) => (value1 - value2)),
    // this is if you want to do a default sort for a specific column
    // sort: this.props.defaultGridSort !== undefined && this.props.defaultGridSort.toLowerCase() === x.dv_column.toLowerCase() ? {
    //   direction: 'desc',
    //   priority: 0
    // } : null,
  }));

  onGridReady = async (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.getData();
  };

  onModelUpdated = (params) => {
    if(this.state.displayedRowCount !== params.api.getDisplayedRowCount())
      this.setState({ displayedRowCount: params.api.getDisplayedRowCount() });
  }

  dateClick = () => {
    this.context.handlers.injectClientReportingIntoDrawer();
  };

  render() {
    // console.log(this.context.state.userAzureID)
    return (
      <DashboardView>
        <GrpHeader
          title="Regulatory Reporting"
          headerItems={[
            <LevelButton
              to={{ pathname: '/regulatory-reporting/insurance' }}
            >
              Insurance
            </LevelButton>,
          ]}
          fileName={(
            <div>
              {this.state.productClassPk}
            </div>
          )}
          headerControls={(
            <ClientAndReportingDate
              onClick={this.dateClick}
              text={(
                <div>
                  <Client>
                    {
                      !this.context.state.selectedClient.name === null ? (
                        'Select Client and Reporting Period'
                      ) : (this.context.state.selectedClient.name)
                    }
                  </Client>
                  <ReportingDate>
                    {
                      (this.context.state.selectedClient.name && this.context.state.selectedReportingDate)
                      && (this.context.state.selectedReportingDate.code)
                    }
                  </ReportingDate>
                </div>
              )}
            />
          )}
        />
        <DashboardBody>
          {
            this.state.failed ? <GrpError text={this.state.failMessage} /> : (
              <>
                {
                  this.state.loading ? <GrpSpinner text="Loading data..." /> : (
                    this.gridApi && (
                      <GrpToolbar
                        api={this.gridApi}
                        working={this.state.toolbarWorking}
                        exportName={this.state.api_name}
                        controls={this.state.toolbarButtons}
                        count={{
                          total: this.state.totalRowCount,
                          showing: this.state.displayedRowCount,
                        }}
                      />
                    )
                  )
                }
                <GrpGrid
                  columnDefs={this.state.columnDefs}
                  rawColumnData={this.state.rawColumns}
                  onGridReady={this.onGridReady}
                  apiName={this.state.api_name}
                  onModelUpdated={this.onModelUpdated}
                  pivotable
                />
              </>
            )
          }
        </DashboardBody>
      </DashboardView>
    );
  }
}

InsPreview.contextType = AppContext;

export default InsPreview;
